import React from 'react';
import StatesOverviewEvaluations from '@/features/dashboard-eval/components/states/StatesOverviewEvaluations';
import ParentLayout from './ParentLayout';

export default function Layout() {
  return (
    <ParentLayout title="Evaluations">
      {function(params) {
        return (
          <>
            <StatesOverviewEvaluations params={params} />
          </>
        );
      }}
    </ParentLayout>
  );
}
